<template>
    <main class="layout-main">
        <router-view />
    </main>
</template>

<script>
console.log( );

export default {
    name: 'layoutMain',
    data(){
        return {
        }
    }
}
</script>

<style lang="scss" scoped>
.layout-main{
    height: 100%;
}
</style>